import logo from 'assets/images/logo-small.svg';
import { Icon } from 'components';
import { useNavigate } from 'react-router-dom';
import { instance } from 'utils/axiosConfig';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import dashboardIcon from 'assets/sprite/dashboard.svg';

import styles from './Header.module.scss';

export const Header = () => {
  const navigate = useNavigate();
  const authTokens = localStorage.getItem('authTokens')
    ? JSON.parse(localStorage.getItem('authTokens'))
    : null;

  const [userName, setUserName] = useState('');
  const [userLastName, setUserLastName] = useState('');

  useEffect(() => {
    instance.get('/subscribers/info/').then(response => {
      const userData = response.data.data;
      setUserName(userData.first_name);
      setUserLastName(userData.last_name);
    });
  }, []);

  const handleLogOut = () => {
    instance.post('/auth/logout', { refresh_token: authTokens.refresh_token }).then(() => {
      localStorage.removeItem('authTokens');
      navigate('/');
    });
  };
  const { t } = useTranslation();

  const checkUserInfo = () => {
    if (userName || userLastName) {
      return (
        <>
          {t('welcome')}, {userName} {userLastName}!
        </>
      );
    }
    return <> {t('welcome')}, User!</>;
  };

  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <div className={styles.main}>
          <div className={styles.head}>
            <div className={styles.welcome}>{checkUserInfo()}</div>
            <button
              onClick={() => {
                handleLogOut();
              }}
              className={styles.logout}
            >
              {t('logout')}
            </button>
          </div>
          <div className={styles.footer}>
            <Icon id={dashboardIcon.id} viewBox={dashboardIcon.viewBox} className={styles.icon} />
            <span className={styles.title}>{t('dashboard')}</span>
          </div>
        </div>
        <div className={styles.logo}>
          <img src={logo} alt="logo" />
        </div>
      </div>
    </div>
  );
};
